/**
 * Upload a cropped JPEG Blob to a Cloudflare direct-upload URL.
 * Does not send application authorisation or JSON content type.
 */
export async function uploadCroppedPicture(uploadUrl, croppedBlob, fetchImpl = fetch) {
  const body = new FormData();
  body.append('file', croppedBlob, 'profile-picture.jpg');

  const response = await fetchImpl(uploadUrl, {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    const error = new Error(`Cloudflare upload failed with status ${response.status}`);
    error.response = response;
    throw error;
  }

  return response;
}
